import React from 'react';
import { Check, Smartphone, Building2 } from 'lucide-react';
interface PaymentMethodProps {
  selectedMethod: 'zelle' | 'cashapp' | null;
  onSelect: (method: 'zelle' | 'cashapp') => void;
}
export function PaymentMethod({
  selectedMethod,
  onSelect
}: PaymentMethodProps) {
  return <div data-id="element-69">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-70">
        <button type="button" onClick={() => onSelect('zelle')} className={`relative p-4 border-2 transition-all duration-200 text-left group ${selectedMethod === 'zelle' ? 'border-[#D4A853] bg-[#D4A853]/5' : 'border-[#E8E8E8] hover:border-[#D4A853]/50'}`} data-id="element-71">
          {selectedMethod === 'zelle' && <div className="absolute top-3 right-3 w-5 h-5 bg-[#D4A853] rounded-full flex items-center justify-center" data-id="element-72">
              <Check size={10} className="text-white" strokeWidth={3} data-id="element-73" />
            </div>}
          <div className="w-full h-10 bg-[#6D1ED4] rounded flex items-center justify-center mb-3" data-id="element-74">
            <span className="text-white font-bold text-sm tracking-wide" data-id="element-75">
              Zelle®
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-76">
            <Building2 size={12} className="text-[#6B6B6B]" data-id="element-77" />
            <p className="text-xs text-[#6B6B6B] font-['Raleway']" data-id="element-78">
              Bank transfer
            </p>
          </div>
        </button>

        <button type="button" onClick={() => onSelect('cashapp')} className={`relative p-4 border-2 transition-all duration-200 text-left group ${selectedMethod === 'cashapp' ? 'border-[#D4A853] bg-[#D4A853]/5' : 'border-[#E8E8E8] hover:border-[#D4A853]/50'}`} data-id="element-79">
          {selectedMethod === 'cashapp' && <div className="absolute top-3 right-3 w-5 h-5 bg-[#D4A853] rounded-full flex items-center justify-center" data-id="element-80">
              <Check size={10} className="text-white" strokeWidth={3} data-id="element-81" />
            </div>}
          <div className="w-full h-10 bg-[#00D632] rounded flex items-center justify-center mb-3" data-id="element-82">
            <span className="text-white font-bold text-sm tracking-wide" data-id="element-83">
              $Cash App
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-84">
            <Smartphone size={12} className="text-[#6B6B6B]" data-id="element-85" />
            <p className="text-xs text-[#6B6B6B] font-['Raleway']" data-id="element-86">
              Mobile payment
            </p>
          </div>
        </button>
      </div>

      {selectedMethod && <div className="mt-4 p-4 bg-[#D4A853]/10 border-l-2 border-[#D4A853]" data-id="element-87">
          {selectedMethod === 'zelle' ? <p className="text-sm text-[#1A1A1A]/70 font-['Raleway'] leading-relaxed" data-id="element-88">
              After placing your order, you'll receive an email with
              instructions to send payment via{' '}
              <span className="font-medium text-[#1A1A1A]" data-id="element-89">Zelle</span> to our
              registered number. Your order ships once payment is confirmed.
            </p> : <p className="text-sm text-[#1A1A1A]/70 font-['Raleway'] leading-relaxed" data-id="element-90">
              After placing your order, you'll receive an email with
              instructions to send payment via{' '}
              <span className="font-medium text-[#1A1A1A]" data-id="element-91">Cash App</span> to{' '}
              <span className="font-medium text-[#1A1A1A]" data-id="element-92">
                $ChristianaBoutique
              </span>
              . Your order ships once payment is confirmed.
            </p>}
        </div>}

      <p className="text-[11px] text-[#6B6B6B] font-['Raleway'] mt-4 text-center" data-id="element-93">
        We currently accept Zelle and Cash App only.
      </p>
    </div>;
}